import * as React from 'react';
import { useRef, useCallback } from 'react';

import { observer } from 'mobx-react';
import { Viewport, ViewSmall, ViewLarge } from 'bernie-view';

import { Playback, SearchTripControls, SearchFormOptions } from '.';
import { useStores } from 'utility/hooks';

export const SearchForm = observer(() => {
  const { searchFormStore, flightsSelectedJourneyReviewStore, listingsStore } = useStores();
  const searchFormHeadingRef = useRef<HTMLHeadingElement>(null);
  const loading = searchFormStore.searchForm.__typename === 'FlightsLoadingSearchForm';

  const closeSideSheet = useCallback(() => {
    flightsSelectedJourneyReviewStore.detailsVisible = false;
    listingsStore.selectedOfferIndex = -1;
  }, [flightsSelectedJourneyReviewStore, listingsStore]);

  return (
    <section role="search" data-test-id="search-form-section">
      <fieldset className={loading ? 'is-disabled' : null}>
        {searchFormStore.searchForm && searchFormStore.searchForm.accessibilityMessage && (
          <h2 className="is-visually-hidden" ref={searchFormHeadingRef} tabIndex={-1}>
            {searchFormStore.searchForm.accessibilityMessage}
          </h2>
        )}
        <Viewport>
          <ViewSmall>
            <Playback searchFormHeadingRef={searchFormHeadingRef} onFieldInteraction={closeSideSheet} />
          </ViewSmall>
          <ViewLarge>
            <div data-test-id="wizard">
              <SearchFormOptions
                options={searchFormStore.searchForm.searchOptions}
                onFieldInteraction={closeSideSheet}
              />
              <SearchTripControls essEndpoint={searchFormStore.essEndpoint} onFieldInteraction={closeSideSheet} />
            </div>
          </ViewLarge>
        </Viewport>
      </fieldset>
    </section>
  );
});
